import { useDispatch, useSelector } from "react-redux";
import { AXES } from "../store/selectors";
import { useEffect, useState } from "react";
import { GetAxes_getAxes } from "../__generated__/gql-types/GetAxes";
import UseGetAxes from "../api/useGetAxes";

export const useAxes = () => {
  const dispatch = useDispatch();
  const axesSelector = useSelector(AXES);
  const [loading, setLoading] = useState(true);
  const [axes, setAxes] = useState<GetAxes_getAxes[]>([]);
  const getAxes = UseGetAxes();

  const fetchInfo = async () => {
    try {
      if (axesSelector?.length > 0) {
        setAxes(axesSelector);
      } else {
        const axesResponse = await getAxes();
        const axesData = axesResponse?.sort(
          (a: GetAxes_getAxes, b: GetAxes_getAxes) =>
            Number(b?.id) - Number(a?.id)
        );
        axesData && setAxes(axesData);
        dispatch({ type: "data/setAxes", payload: axesData });
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      throw new Error(error);
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  return {
    axes,
    loading,
  };
};
